export default "/images/vendor/flag-icons/flags/1x1/am.svg?eaae878c684895ebbfbd8dbe878ca0a2";